export const DEAL_STATUSES = {
  closed: 'closed',
  draft: 'draft',
  finalized: 'finalized',
  cancelled: 'cancelled',
  refunded: 'refunded',
  unsubscribed: 'unsubscribed',
  ready: 'ready',
}
export const DEAL_STATUSES_BADGES_MAP = {
  closed: 'paid',
  draft: 'draft',
  finalized: 'pending',
  cancelled: 'canceled',
  refunded: 'refunded',
  unsubscribed: 'unsubscribed',
  ready: 'ready',
}
